import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { Router } from '@angular/router';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],

})
export class LeftMenuComponent implements OnInit {

  // public menuItems: Menu[];
  @Input() menuCustom: any = [];

  constructor(
    private router: Router,
    public navServices: NavService,
    private menuService: MenuService,


  ) {
    // this.navServices.leftMenuItems.subscribe(menuItems => this.menuItems = menuItems);
    this.router.events.subscribe((event) => {
      this.navServices.mainMenuToggle = false;
    });

   

  }



  ngOnInit(): void {
  }

  leftMenuToggle(): void {
    this.navServices.leftMenuToggle = !this.navServices.leftMenuToggle;
  }

  // Click Toggle menu (Mobile)
  toggletNavActive(item) {
    item.active = !item.active;
  }

  onHover(menuItem) {
    if (window.innerWidth > 1200 && menuItem) {
      document.getElementById('unset').classList.add('sidebar-unset')
    } else {
      document.getElementById('unset').classList.remove('sidebar-unset')
    }
  }


  getMenus() {
    this.menuService.getMenu.subscribe(data => {
      console.log('Menu Items:', data['VENDOR']);
      this.menuCustom = data['menu'];
    });
  }


  menuItems: Menu[] = [
    {
      title: 'Dashboard', type: 'link', megaMenu: true, active: false,  path:'/vendor'
      // children: [
        // {
        //   title: 'mens fashion', type: 'link', active: false, children: [
        //     { path: '/home/fashion', title: 'sports wear', type: 'link' },
        //     { path: '/home/fashion', title: 'top', type: 'link' },
        //     { path: '/home/fashion', title: 'bottom', type: 'link' },
        //     { path: '/home/fashion', title: 'ethic wear', type: 'link' },
        //     { path: '/home/fashion', title: 'sports wear', type: 'link' },
        //     { path: '/home/fashion', title: 'shirts', type: 'link' },
        //     { path: '/home/fashion', title: 'bottom', type: 'link' },
        //     { path: '/home/fashion', title: 'ethic wear', type: 'link' },
        //     { path: '/home/fashion', title: 'sports wear', type: 'link' }
        //   ]
        // },
      // ]
    }
  ]



}
